import { base64ToBlob } from '../../../helpers/decode';
import comprovanteService from '../../../services/pdfs/comprovanteService';
import { showMessageError,showMessageSuccess,showMessageAlert } from '../../others/toastr';
import axios from 'axios';

class ComprovanteAdesaoController {
    async geraComprovanteAdesaoController(bodyComprovanteAdesao) {
        try {
            showMessageAlert('Aguarde','Estamos gerando o comprovante de pagamento da adesão.');

            const responseGeraComprovanteAdesao = await comprovanteService.geraComprovanteAdesao(bodyComprovanteAdesao);
            const base64Data = responseGeraComprovanteAdesao;
            
            const link = document.createElement('a');
           
            const blob = base64ToBlob(base64Data, 'application/pdf');
          
            const url = URL.createObjectURL(blob);
        
            link.href = url;
            link.download = 'comprovante-pagamento-adesao.pdf';
           
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            showMessageSuccess('Sucesso!', 'Comprovante de pagamento da adesão gerado.');
        } catch (error) {
            if (axios.isAxiosError(error)){
                showMessageError('Erro', 'Tivemos problemas ao gerar o comprovante, por gentileza tente novamente.');
            }

            throw error;
        }
    }
}

export default new ComprovanteAdesaoController();
